export default __webpack_public_path__ + "images/bcc385a8fdb7f8890a745fc5e7989fc0-mountain_biking_small.webp";